import type { Move } from '../../../schemas/move';

/**
 * ***Esperto Multiclasse*** — mossa comune oltre il 10° livello (manuale V1
 * rr. 1805-1809). Richiede *Adepto Multiclasse*.
 *
 * Effetto: scegli una mossa **iniziale** o **avanzata di livello 2-5** di
 * un'altra classe. Non prendere mosse multiclasse. (Pool identico a Adepto;
 * la differenza è che Esperto è il 3° step della catena ed è un'altra mossa
 * separata.)
 */
export const espertoMulticlasse: Move = {
  id: 'common.esperto-multiclasse',
  name: 'Esperto Multiclasse',
  type: 'common',
  trigger: 'Quando prendi questa mossa al level-up (oltre il 10° livello)',
  description:
    "Scegli una mossa iniziale o una avanzata di livello 2-5 da un'altra classe. Non prendere mosse multiclasse.",
  tags: ['multiclasse'],
  prerequisites: ['common.adepto-multiclasse'],
  replaces: [],
  multiclass: {
    picks: { kind: 'any-other-class' },
    levelAdjustment: { delta: -5 },
  },
};
